import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './utils/debug'; // Initialize debug utilities

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);